'use strict'

var Marionette = require('marionette')
var Backbone = require('backbone')
var App = require('app')
var _ = require('lodash')

var View = require('./view.js')

var DevicesList = function () {
  var Controller = Marionette.Object.extend({
    listDevices: function (options) {
      var self = this

      self.region = options.region

      if (options.devices) {
        self.devices = options.devices
      } else {
        // self.devices = App.globalChannel.request('device:entities')
      }
      if (options.devicesGeo) {
        self.devicesGeo = options.devicesGeo
      }
      self.layout = self.getLayoutView(self.devices)

      // temporary setup
      // self.layout.on('toggle:list', function () {
      //   // App.globalChannel.trigger('devices:list', {devices: self.devices, region: self.region})
      // })
      self.layout.on('toggle:map', function () {
        App.globalChannel.trigger('devices:map', {devices: self.devices, devicesGeo: self.devicesGeo, region: self.region})
      })

      this.listenTo(self.layout, 'render', function () {
        self.listRegion(self.devices)
      })
      self.layout.on('render', function () {})
      //
      self.region.show(self.layout)
    // App.rootLayout.showChildView('mainRegion', self.layout)
    },
    listRegion: function (collection, columns) {
      var self = this
      //
      var columns = {
        '_bulk': {
          'options': {
            // 'edit': {'label': 'Edit','roles': ['master']},
            'edit': {'label': 'Edit', 'roles': ['super', 'admin']},
            'control': {'label': 'Control', 'roles': ['super', 'admin']},
            'delete': {'label': 'Delete', 'roles': ['super', 'admin']}
          }
        },
        'status': {'label': '', 'sortable': false, 'roles': [] },
        'name': {'label': 'name', 'sortable': true, 'roles': [] },
        'client': {'label': 'client', 'sortable': true, 'roles': ['super', 'admin'], 'hideSizes':['mobile','tablet'] },
        'type': {'label': 'type', 'sortable': true, 'roles': [], 'hideSizes':['mobile','tablet']},
        'firmwareVersion': {'label': 'firmware', 'sortable': true, 'roles': ['super', 'admin'] },
        'lastSeenAt': {'label': 'last seen', 'sortable': true, 'roles': [], 'hideSizes':['mobile','tablet']},
        '_actions': {
          'options': {
            'edit': { 'action': 'edit', 'roles': ['super', 'admin'], 'hideSizes':['mobile'] },
            'control': { 'action': 'control', 'roles': ['super', 'admin'], 'hideSizes':['mobile'] },
            'manage': {'action': 'manage', 'roles': []}
          }
        }
      }

      //
      var emptyViewModel = new Backbone.Model({
        title: 'Whoops! no devices found.',
        subTitle: 'try broadening your filter criteria'
      })

      //
      var layout = this.getListView(collection, columns, emptyViewModel)

      // view events
      // self.layout.on('childview:device:edit', _.bind(self.onEdit, self))
      // self.layout.on('childview:device:control', _.bind(self.onControl, self))
      // self.layout.on('childview:device:show', _.bind(self.onShow, self))
      self.listenTo(layout, 'listview:childview:item:edit', self.onEdit)
      self.listenTo(layout, 'listview:childview:item:control', self.onControl)
      self.listenTo(layout, 'listview:childview:item:manage', self.onShow)
      //
      self.listenTo(layout, 'bulk:edit', self.onBulkEdit)

      self.listenTo(layout, 'bulk:control', self.onBulkControl)
      self.listenTo(layout, 'bulk:action', self.onBulk)

      self.layout.getRegion('listRegion').show(layout)
    },
    onBulk: function (args) {
      let collection = args.collection
      switch (args.bulk_action) {
        case 'edit':
          // App.globalChannel.trigger('client-nodes:edit', {region: App.rootLayout.getRegion('dialogRegion'), collection: args.collection, client: this.client, bulkAction: true})
          break
        case 'delete':
          App.dialog.confirm({
            message: App.TextParser('CONFIRM_BULK_DELETE'),
            callback: function (confirmed) {
              if (confirmed) {
                collection.bulkDelete({callback:(err, response) => {
                  if (err) {
                    App.dialog.alert({
                      unsafeMessage: '<h3>The items could not be deleted.</h3>' + err.responseJSON.message
                    })
                  }
                }})
              }
            }
          })
          break
        default:
          console.warn('Bulk action not catched by switch, "' + args.bulk_action + '"')
          break
      }
    },
    onShow: function (args) {
      App.globalChannel.trigger('device:show', {model: args.model})
    },
    onControl: function (args) {
      App.globalChannel.trigger('device:control', {region: App.rootLayout.getRegion('dialogRegion'), device: args.model})
    },
    onEdit: function (args) {
      App.globalChannel.trigger('device:edit', {region: App.rootLayout.getRegion('dialogRegion'), device: args.model})
    },
    onBulkControl: function (args) {
      var deviceTypes = _.uniq(_.map(args.collection.where({_bulk: true}), 'attributes.type'))
      if (deviceTypes.length > 1) {
        App.dialog.alert({
          message: App.TextParser('NOTICE_BULK_DEVICETYPE')
        })
        return
      }
      //  if (deviceTypes.length === 1) self.deviceType = deviceTypes[0]
      App.globalChannel.trigger('device:control', {region: App.rootLayout.getRegion('dialogRegion'), collection: args.collection, bulkAction: true})
    },
    onBulkEdit: function (args) {
      App.globalChannel.trigger('device:edit', {region: App.rootLayout.getRegion('dialogRegion'), collection: args.collection, bulkAction: true})
    },
    getListView: function (collection, columns, emptyViewModel) {
      // create the listview based on the list component
      return new View.listView({
        collection: collection,
        columns: columns,
        emptyViewModel: emptyViewModel,
        childView: View.listItem // use a custom childview
      })
    },
    getLayoutView: function (collection) {
      return new View.layout({collection: collection})
    }
  })

  return new Controller()
}

module.exports = DevicesList



// WEBPACK FOOTER //
// ./js/modules/devices/list/index.js